import React from 'react'
import { Icon, Tag } from 'antd'
import { transitions } from '../../helper/data.video'

const TransitionDisplay = ({ type, onRemove }) => {
  // Handle both old string format and new object format
  const transitionType = typeof type === 'string' ? type : type?.transition
  const duration = typeof type === 'object' ? type?.duration : null

  const transition = transitions.find(t => t.id === transitionType) || null

  if (!transition) {
    return <Icon type="plus" className="video-transition-icon" />
  }

  return (
    <div className="selected-transition">
      <h3>Transition</h3>

      <Tag
        closable
        onClose={e => {
          e.preventDefault()
          e.stopPropagation()
          onRemove(transitionType)
        }}
        className="selected-transition__tag"
      >
        <span className="video-transition-icon">
          <transition.icon />
        </span>
        {transition.name}
        {duration && (
          <span className="transition-duration-badge">{duration}s</span>
        )}
      </Tag>
    </div>
  )
}

export default TransitionDisplay
